module.exports = __webpack_public_path__ + "img/6.6365f209.jpg";